module.exports = __webpack_public_path__ + "fonts/Nunito-ExtraBold.19caf1c.ttf";